import React, { FC } from 'react';

export interface GothamFontsProps {}

const GothamFonts: FC<GothamFontsProps> = () => {
  // HOOKS END

  return (
    <React.Fragment>
      <link
        rel="preconnect"
        href="https://d1rlzbup3qx51x.cloudfront.net"
        crossOrigin=""
        key="gotham-stylesheet-preconnect"
      />
      <style key="gotham-style-tag">
        {`
          @font-face {
            font-family: "Gotham Rounded";
            src: url("https://d1rlzbup3qx51x.cloudfront.net/fonts/hco_fonts/woff2/GothamRndSSm-Medium_Web.woff2")
                format("woff2"),
              url("https://d1rlzbup3qx51x.cloudfront.net/fonts/hco_fonts/woff/GothamRndSSm-Medium_Web.woff")
                format("woff");
            font-weight: 500;
            font-style: normal;
            font-display: fallback;
          }

          @font-face {
            font-family: "Gotham Rounded";
            src: url("https://d1rlzbup3qx51x.cloudfront.net/fonts/hco_fonts/woff2/GothamRndSSm-Bold_Web.woff2")
                format("woff2"),
              url("https://d1rlzbup3qx51x.cloudfront.net/fonts/hco_fonts/woff/GothamRndSSm-Bold_Web.woff")
                format("woff");
            font-weight: 700;
            font-style: normal;
            font-display: fallback;
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default GothamFonts;
